<template>
  <v-tooltip top class="tooltip-botao-baixar-todos">
    <a slot="activator" :class="`baixar-todos-documentos ${colorClass} ${deshabilitar ?  'deshabilidato' : 'habilitado'}`" @click="$emit('baixarTodosDocumentos')">
      <i size="15" :class="`fas fa-download ma-0 ${colorClass}`" aria-hidden="true"/>
      <span class="ml-1">{{ texto }}</span>
    </a>
    {{ deshabilitar ? 'Não existem documentos disponíveis na compra.' : 'Baixar todos os documentos enviados pelo fornecedor.' }}
  </v-tooltip>
</template>

<script>
export default {
    name: 'BotaoBaixarTodos',
    props:{
        texto:{
            type: String,
            default: 'Baixar'
        },
        colorClass:{
            type: String,
            default: 'secondary-color'
        },
        deshabilitar: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped lang="stylus">
    a.baixar-todos-documentos *
        background-color transparent

    a.baixar-todos-documentos
        margin-left 10px
        min-width 50px
        font-size 13px
        display block

    a.deshabilidato
        pointer-events none


    .primary-color
        color var(--v-primary-lighten1) !important

    .secondary-color
        color var(--v-primary-lighten1) !important

    i
        font-size 13px
        top 0

</style>
